/*
 Custom selection of facets for the scoped portal view.
 Extended view will show all facets available on ESGF.
 */
export const CMIP7memberList = [
    'r1i1p1f1',
    'r2i1p1f1',
    'r3i1p1f1',
    'r4i1p1f1',
    'r5i1p1f1',
    'r6i1p1f1',
    'r10i1p1f1',
    'r9i1p1f1',
    'r7i1p1f1',
    'r8i1p1f1',
    'r1i1p2f1',
    'r11i1p1f1',
    'r14i1p1f1',
    'r12i1p1f1',
];
export const cordexCMIP6memberList = [
    'r1i1p1f1',
    'r2i1p1f1',
    'r1i1p1f2',
    'r3i1p1f1',
    'r4i1p1f1',
    'r5i1p1f1',
    'r1i1p2f1',
];
export const CMIP6memberList = [
    'r1i1p1f1',
    'r2i1p1f1',
    'r1i1p1f2',
    'r3i1p1f1',
    'r4i1p1f1',
    'r5i1p1f1',
    'r6i1p1f1',
    'r10i1p1f1',
    'r9i1p1f1',
    'r7i1p1f1',
    'r8i1p1f1',
    'r2i1p1f2',
    'r1i1p2f1',
    'r3i1p1f2',
    'r4i1p1f2',
    'r11i1p1f1',
    'r1i1p3f1',
    'r14i1p1f1',
    'r5i6p1f2',
    'r12i1p1f1',
];
export const CMIP5EnsembleList = [
    'r0i0p0',
    'r10i1p1',
    'r10i2p1',
    'r1i1p1',
    'r1i2p1',
    'r1i3p1',
    'r2i1p1',
    'r2i2p1',
    'r2i3p1',
    'r3i1p1',
    'r3i2p1',
    'r4i1p1',
    'r4i2p1',
    'r4i3p1',
    'r5i1p1',
    'r5i2p1',
    'r5i3p1',
    'r6i1p1',
    'r6i2p1',
    'r7i1p1',
    'r7i2p1',
    'r8i1p1',
    'r8i2p1',
    'r8i3p1',
    'r9i1p1',
    'r9i2p1',
];
